

import { useEffect, useState } from 'react'
import { initialQueryState } from '../../_metronic/helpers'
import { useQueryRequest } from './request'
import { DwonloadCsv } from './downloadCsv'
import { useAuth } from '../modules/auth'
/**
 * OrderFilter Component
 *
 * Provides a filter UI for orders, allowing users to filter by segment and category.
 *
 * Features:
 * - Syncs filter state with segment and category selections
 * - Updates global query state for data filtering
 * - Allows resetting and applying filters
 * - Dynamically updates category options based on selected segment
 *
 * Props:
 * - orderFilter: Object containing segment and category filter options
 */
const OrderFilter = ({ orderFilter }) => {
    const { updateState } = useQueryRequest()
    //const { isLoading } = useQueryResponse()
    const [segment, setSegment] = useState()
    const [category, setCategory] = useState()

    useEffect(() => {

    }, [orderFilter])

    useEffect(() => {
        if (segment || category) {
            filterData()
        }

    }, [segment, category])

    const resetData = () => {
        setCategory('')
        setSegment('')
        updateState({ filter: undefined, ...initialQueryState })
    }
    // const getFilter = () => {
    //     getFilterOption().then((d) => setFilterOption(d.data))
    // }

    const filterData = () => {
        updateState({
            filter: { segment, category },
            search: null,
            ...initialQueryState
        })
    }

    return (
        <>
            {/* begin::Content */}
            <div className='d-md-flex  gap-5' data-kt-user-table-filter='form'>
                {/* begin::Input group */}
                <div className='mb-1'>
                    <label className='form-label fs-6 fw-semibold'>Filter By Segment :</label>
                    <select
                        className='form-select w-250px  form-select-solid fw-semibolder'
                        data-kt-select2='true'
                        data-placeholder='Select option'
                        data-allow-clear='true'
                        data-kt-user-table-filter='role'
                        data-hide-search='true'
                        onChange={(e) => {
                            setSegment(e.target.value)
                            setCategory('')
                        }}
                        value={segment}
                    >
                        <option value=''>Select</option>

                        {orderFilter?.segmnet?.length > 0 &&

                            orderFilter?.segmnet.map((pro) => {

                                return <option value={pro?.id}>{pro?.business_segment_name}</option>
                            })
                        }


                    </select>
                </div>
                <div className='mb-1'>
                    <label className='form-label fs-6 fw-semibold'>Filter By Category :</label>
                    <select
                        className='form-select w-250px form-select-solid fw-semibolder'
                        data-kt-select2='true'
                        data-placeholder='Select option'
                        data-allow-clear='true'
                        data-kt-user-table-filter='role'
                        data-hide-search='true'
                        onChange={(e) => setCategory(e.target.value)}
                        value={category}
                    >
                        <option value=''>Select</option>

                        {orderFilter?.category?.[segment]?.length > 0 &&
                            orderFilter.category[segment].map((cate) => {

                                return <option key={cate.id} value={cate.id}>{cate.category_name}</option>
                            })
                        }

                    </select>
                </div>
                <div className='mb-1'><label className='form-label fs-6 fw-semibold'></label>
                    <div className='pt-4'>
                        <button onClick={() => resetData()} disabled={!(category || segment)} className='btn btn-sm btn-danger'><i class="bi fs-2 bi-bootstrap-reboot"></i></button>
                    </div>
                </div>
                {/* end::Input group */}
            </div>
        </>
    )
}

/**
 * OrderStatusFilter Component
 *
 * Provides a filter UI for order status, allowing users to filter by status and download CSV if permitted.
 *
 * Features:
 * - Syncs filter state with status selection
 * - Updates global query state for data filtering
 * - Allows resetting and applying status filter
 * - Shows download button if user has permission
 */

const OrderStatusFilter = () => {
    const { currentUser } = useAuth()
    const { updateState } = useQueryRequest()
    //  const { isLoading } = useQueryResponse()
    const [status, setStatus] = useState()
    useEffect(() => {
        if (status) {
            filterData()
        }
    }, [status])

    const resetData = () => {
        setStatus('')
        updateState({ filter: undefined, ...initialQueryState })
    }

    const filterData = () => {
        updateState({
            filter: { status },
            search: null,
            ...initialQueryState
        })
    }

    return (
        <div className='d-flex gap-2'>

            <select
                className='form-select w-250px form-select-lg form-select-solid fw-semibolder'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                data-kt-user-table-filter='role'
                data-hide-search='true'
                onChange={(e) => {
                    setStatus(e.target.value)
                }}
                value={status}
            >
                <option value=''>Select Status</option>
                <option value='pending'>Pending</option>
                <option value='accept'>Accepted </option>
                <option value='partial'>Partial</option>
                {/* <option value='partAcc'>Partail Accepted </option> */}
                <option value='reject'>Rejected</option>
                {/* <option value='dispatched'>Dispatched</option> */}
                {/* <option value='partDis'>Partial Dispatched</option> */}
            </select>



            <button onClick={() => resetData()} disabled={!(status)} className='btn btn-lg btn-danger'><i class="bi fs-2 bi-bootstrap-reboot"></i></button>

            {currentUser?.accesses?.permissions?.includes('download') ?
                <DwonloadCsv type={'all'} className="btn btn btn-primary btn-lg fw-semibold  me-3" />
                : <div className='badge badge-light-danger fw-semibolder'>Permission Denied</div>
            }
        </div>
    )
}
export { OrderFilter, OrderStatusFilter }


